import { render, staticRenderFns } from "./create.vue?vue&type=template&id=a342fcfa&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=a342fcfa&prod&lang=css&"
import style1 from "./create.vue?vue&type=style&index=1&id=a342fcfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a342fcfa",
  null
  
)

export default component.exports